import { CommonDropdownOptions } from '@ardoq/global-consts';

/**
 * DEFAULT_TRAVERSE_SETTINGS and DEFAULT_TRAVERSE_REFERENCE_TYPES are not needed in
 * viewpoint mode, we therefore don't persist them.
 *
 * However, currently, they are artifacts of the shared view model functions, so we
 * have to maintain them in the app state also in viewpoint mode.
 */
export const DEFAULT_TRAVERSE_SETTINGS = {
  incomingDegreesOfRelationship: 0,
  outgoingDegreesOfRelationship: 0,
  depthOfRelationship: 1,
};
export const DEFAULT_TRAVERSE_REFERENCE_TYPES = {
  includeOutgoingReferenceTypeNames: [CommonDropdownOptions.ALL],
  includeIncomingReferenceTypeNames: [CommonDropdownOptions.ALL],
};

export const DEFAULT_WORKSPACE_MODE_TRAVERSE_SETTINGS = {
  ...DEFAULT_TRAVERSE_SETTINGS,
  ...DEFAULT_TRAVERSE_REFERENCE_TYPES,
  showOnlyConnectedComponents: false,
};
